<template>
    <v-container text-xs-center mt-5 pt-5 class="d-flex justify-center align-center" style="min-height: 80vh">


        <!-- Error Alert -->

        <v-layout v-if="error" row wrap>
            <v-flex xs12 sm6 md6>
                <form-alert :message="error"></form-alert>
            </v-flex>
        </v-layout>

        <v-layout row>

            <v-flex xs12 sm6 md6 mx-auto>
            <h1 class="pb-3">تسجيل الدخول</h1>

                    <v-form v-model="isFormValid" lazy-validation ref="form" @submit.prevent="handleSignIn">
                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field color="#252625" :rules="emailRules" v-model="email" prepend-icon="mdi-email"
                                    label="البريد الالكتروني" type="email" required outlined></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field color="#252625" :rules="passwordRules" v-model="password" prepend-icon="mdi-information"
                                    label="كلمة المرور" type="password" required outlined></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs12>
                                <v-btn class="mb-5" :loading="loading" :disabled="!isFormValid || loading" color="#EFAA42"
                                    type="submit">
                                    <template v-slot:loader>
                                        <span class="custom-loader">
                                            <v-icon light>mdi-cached</v-icon>
                                        </span>
                                    </template>
                                    الدخول</v-btn>
                                <h3>ليس لديكم حساب مسبقا؟ <router-link style="color: #EFAA42" to="/signup">إنشاء حساب</router-link>
                                </h3>
                            </v-flex>
                        </v-layout>

                    </v-form>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'

    export default {
        name: 'Signin',
        data() {
            return {
                isFormValid: true,
                email: "",
                password: "",
                emailRules: [
                    email => !!email || "الايميل مطلوب",
                    email => /.@+./.test(email) || 'يجب ان يكون البريد الاكتروني صحيح'
                ],
                passwordRules: [
                    // Check if password in input
                    password => !!password || "كلمة المرور مطلوبة",
                    // Make sure name is less than 10 char
                    password => password.length >= 4 || "كلمة المرور لا تقل عن 7 أحرف"

                ]
            }
        },
        computed: {
            ...mapGetters(['user', 'loading', 'error'])
        },
        watch: {
            user(value) {
                // If user value changes, redirect to home page
                if (value) {
                    this.$router.push('/')
                }
            }
        },
        methods: {
            handleSignIn() {
                if (this.$refs.form.validate()) {
                    this.$store.dispatch('signin', {
                        email: this.email,
                        password: this.password
                    })
                }

            }
        }
    }
</script>

<style>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }

    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }

    @keyframes loader {
        from {
            transform: rotate(0);
        }

        to {
            transform: rotate(360deg);
        }
    }
</style>